import classNames from 'classnames';

import professionSalaryDynamicsButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_salary_dynamics_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button, Card, Text } from '@hh.ru/magritte-ui';

import { StatisticDetailItem } from 'src/models/pages/profession';
import { getCurrencyRange } from 'src/utils/currency';

import styles from './styles.less';

const TrlKeys = {
    vacancy: 'career-platform.profession.sections.statistic.detail.info.vacancy',
    percent: 'career-platform.profession.sections.statistic.detail.info.percent',
    salary: 'career-platform.profession.sections.statistic.detail.info.salary',
    button: 'career-platform.profession.sections.statistic.detail.info.redirect',
};

interface Props {
    item: StatisticDetailItem;
    isMobile: boolean;
}

const DetailChartBarInfo: TranslatedComponent<Props> = ({ trls, item, isMobile }) => (
    <Card padding={12} borderRadius={16} borderBottomLeftRadius={24} borderBottomRightRadius={24} showBorder>
        <div className={styles.content}>
            <div className={styles.row}>
                <div className={styles.title}>
                    <Text typography="label-3-regular" style="secondary" Element="p">
                        {trls[TrlKeys.vacancy]}
                    </Text>
                </div>
                <div className={styles.value}>
                    <Text typography={isMobile ? 'subtitle-2-semibold' : 'subtitle-1-semibold'} Element="p">
                        {item.count}
                    </Text>
                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.title}>
                    <Text typography="label-3-regular" style="secondary" Element="p">
                        {trls[TrlKeys.percent]}
                    </Text>
                </div>
                <div className={styles.value}>
                    <Text
                        typography={isMobile ? 'subtitle-2-semibold' : 'subtitle-1-semibold'}
                        Element="p"
                    >{`${item.percent}%`}</Text>
                </div>
            </div>
            <div className={classNames(styles.row, styles.row_salary)}>
                <div className={styles.title}>
                    <Text typography="label-3-regular" style="secondary" Element="p">
                        {trls[TrlKeys.salary]}
                    </Text>
                </div>
                <div className={styles.value}>
                    <Text typography={isMobile ? 'subtitle-2-semibold' : 'subtitle-1-semibold'} Element="p">
                        {getCurrencyRange(item.salary.from, item.salary.to)}
                    </Text>
                </div>
            </div>
        </div>
        <Button
            mode="secondary"
            style="neutral"
            stretched
            disabled={!item}
            Element="a"
            onClick={() => professionSalaryDynamicsButtonClick({ buttonName: 'vacancies' })}
            href={item.redirect.link}
            target="_blank"
            rel="noreferrer noopener"
        >
            {trls[TrlKeys.button]}
        </Button>
    </Card>
);

export default translation(DetailChartBarInfo);
